import type { FC, ReactElement } from 'react';

import type { IClassNameProps } from '@bem-react/core';

import type { IconProps } from '../../Icon';
import { cnButton } from '../Button.cn';

import './Button-Icon.css';

export type IconProvider = (className: string) => ReactElement<IconProps>;

export interface IButtonIconProps extends IClassNameProps {
    side?: 'left' | 'right';
    provider: IconProvider;
}

export const ButtonIcon: FC<IButtonIconProps> = ({ side, provider, ...props }) => {
    const className = cnButton('Icon', { side }, [props.className]);

    return provider(className);
};
